import { render } from "./OrderDetailHeader.vue?vue&type=template&id=193bd3ea&ts=true"
import script from "./OrderDetailHeader.vue?vue&type=script&lang=ts"
export * from "./OrderDetailHeader.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__